import React from "react";
import { Spinner } from "sr/helpers";

export const LoaderFullScreen = ({ message = "" }) => {
  return (
    <div className="bg-white/90 fixed -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2 min-h-screen w-full z-50">
      <div
        role="status"
        className=" min-h-screen w-full z-50 flex flex-col justify-center items-center"
      >
        <Spinner size={`w-10 h-10`} className={`pl-2`} />
        <span className="mt-3">{message}</span>
      </div>
    </div>
  );
};
